import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import BASE_URL from "../../BaseUrl.jsx";

const StudentsPage = ({
  active,
  setActive,
  mobilActive,
  setMobileActive,
}) => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);

  // Fetch students
  const fetchStudents = async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${BASE_URL}/teacher/my-students`, { withCredentials: true });

      setStudents(response.data);
    } catch (error) {
      console.error("Error fetching students:", error);
      alert("حدث خطأ أثناء تحميل الطلاب");
    } finally {
      setLoading(false);
    }
  };

  // Delete student
  const deleteStudent = async (id) => {
    // const confirmed = window.confirm(
    //   "هل أنت متأكد من حذف هذا الطالب؟"
    // );

    // if (!confirmed) return;

    try {
      setDeletingId(id);

      await axios.delete(`${BASE_URL}/teacher/delete-student?studentId=${id}`, { withCredentials: true });

      setStudents((prev) =>
        prev.filter((student) => student.id !== id)
      );

    } catch (error) {
      console.error("Error deleting student:", error);
      alert("حدث خطأ أثناء حذف الطالب");
    } finally {
      setDeletingId(null);
    }
  };

  // Fetch students when page opens
  useEffect(() => {
    setActive("الملف الشخصي");
    setMobileActive("profile mobile");
    fetchStudents();
  }, []);

  return (
    <Box
      dir="rtl"
      sx={{
        p: { xs: 2, md: 4 },
        minHeight: "100vh",
        backgroundColor: "#f5f6fa",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          الطلاب
        </Typography>

        <Button
          variant="outlined"
          onClick={fetchStudents}
          disabled={loading}
        >
          تحديث القائمة
        </Button>
      </Box>

      {/* Students Table */}
      <Paper
        elevation={2}
        sx={{
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f0f2f5" }}>
                <TableCell align="center">
                  <strong>اسم الطالب</strong>
                </TableCell>

                <TableCell align="center">
                  <strong>البريد الإلكتروني</strong>
                </TableCell>

                <TableCell align="center">
                  <strong>الإجراءات</strong>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={3} align="center" sx={{ py: 5 }}>
                    <CircularProgress />
                    <Typography sx={{ mt: 2 }}>
                      جاري تحميل الطلاب...
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : students.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} align="center" sx={{ py: 5 }}>
                    لا يوجد طلاب
                  </TableCell>
                </TableRow>
              ) : (
                students.map((student) => (
                  <TableRow
                    key={student.id}
                    hover
                  >
                    <TableCell align="center">
                      {student.name}
                    </TableCell>

                    <TableCell align="center">
                      {student.email}
                    </TableCell>

                    <TableCell align="center">
                      <Tooltip title="حذف الطالب">
                        <span>
                          <IconButton
                            color="error"
                            onClick={() => deleteStudent(student.id)}
                            disabled={deletingId === student.id}
                          >
                            {deletingId === student.id ? (
                              <CircularProgress size={22} color="error" />
                            ) : (
                              <DeleteIcon />
                            )}
                          </IconButton>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default StudentsPage;